var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { height: _vm.domHeight + "px" } },
    [
      _c(
        "div",
        { staticClass: "org-tree-layout", attrs: { name: "org_tree" } },
        [
          _c("swb-popover-org-tree", {
            attrs: {
              showRealCom: true,
              onlyShowRealCom: true,
              prftFlag: false,
              selectRealComId: _vm.selectRealComId
            },
            on: {
              "notity-change": function($event) {
                _vm.checkComCatChange($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("swb-contract-search", {
        ref: "swb_contract_search",
        attrs: {
          name: "contract_search",
          queryRef: _vm.queryRef,
          contractType: _vm.contractType,
          isFstParty: true,
          tag: _vm.fstPartyFlag
        },
        on: { "notity-syncRefresh": _vm.searchSyncRefresh }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab-container small base", attrs: { name: "tabs" } },
        [
          _c("div", { staticClass: "tabs-nav" }, [
            _c(
              "ul",
              { staticClass: "head" },
              _vm._l(_vm.contractStateList, function(text, value) {
                return _c(
                  "li",
                  {
                    staticClass: "head-item",
                    class: { current: value == _vm.checkStateValue },
                    on: {
                      click: function($event) {
                        _vm.changeStatue(value)
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(text))])]
                )
              })
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "simple-row", attrs: { name: "btns" } }, [
        _c("div", { staticClass: "left" }, [
          _vm.checkActionPerm("add")
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.goRegisterContract()
                    }
                  }
                },
                [_c("span", [_vm._v("新增合同")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "ml15",
                  on: { change: _vm.changeCheckBox },
                  model: {
                    value: _vm.relevanceCallBid,
                    callback: function($$v) {
                      _vm.relevanceCallBid = $$v
                    },
                    expression: "relevanceCallBid"
                  }
                },
                [_vm._v("关联招投标")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "ml15",
                  on: { change: _vm.changeCheckBox },
                  model: {
                    value: _vm.relevanceReply,
                    callback: function($$v) {
                      _vm.relevanceReply = $$v
                    },
                    expression: "relevanceReply"
                  }
                },
                [_vm._v("关联询价单")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            [
              _c(
                "el-checkbox",
                {
                  staticClass: "ml15",
                  on: { change: _vm.changeCheckBox },
                  model: {
                    value: _vm.userCreate,
                    callback: function($$v) {
                      _vm.userCreate = $$v
                    },
                    expression: "userCreate"
                  }
                },
                [_vm._v("自己创建")]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.contractType == _vm.goodsPurch.value
          ? _c("div", { staticClass: "right" }, [
              _c(
                "a",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-primary",
                  on: { click: _vm.generalImport }
                },
                [_vm._v("合同导入")]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("swb-result-table", {
        ref: "result_table",
        attrs: {
          name: "result_table",
          btnColBaseCount: 2,
          btnColMoreTitle: "更多操作",
          confKey: _vm.confKey,
          configAuto: true,
          needPager: _vm.needPager,
          multiSelect: _vm.multiSelect,
          multiPageSelect: _vm.multiPageSelect,
          rowKeyPropName: _vm.rowKeyPropName,
          rowNoShow: _vm.rowNoShow,
          rowNoFixed: _vm.rowNoFixed,
          btnColName: _vm.btnColName,
          btnColTitle: _vm.btnColTitle,
          btnColWidth: _vm.btnColWidth,
          btnColFixed: _vm.btnColFixed,
          height: _vm.tableHeight,
          pageNoChangeHandler: _vm.pageNoChangeHandler,
          rowDblClickHandler: _vm.rowDblClickHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4db796f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4db796f5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ComnContractList.vue
// module id = 3295
// module chunks = 0